import React, {useState, useEffect, useCallback} from 'react'

// Deps
import {connect} from 'react-redux';
import {LineChart, Line, Tooltip, ResponsiveContainer, Legend, XAxis, CartesianGrid} from 'recharts';
import startOfMonth from 'date-fns/startOfMonth';
import subMonths from 'date-fns/subMonths';
import debounce from 'lodash/debounce'

// Partials
import Loader from 'views/shared/partials/loader'
import Link from 'views/shared/partials/link'
import Pricebox from 'views/shared/partials/pricebox'
import Btn from 'views/shared/partials/btn'
import {FormInput} from 'views/shared/partials/forms'

// Utils
// import { openModal } from 'utils/modals';

// Sections
import PaymentList from 'views/admin/sections/payment-list'

// Functions
import formatDate from 'functions/format-date'
import getCurrency from 'functions/get-currency'
import format from 'date-fns/format'

// Services
//import userServices from 'services/user'
import reportServices from 'services/report'
import orderServices from 'services/order'

// Fixed Data
import currencyTypes from 'data/currency-types'

const today = new Date();

const mapStateToProps = (state, ownProps) => {
    return {
        userData: state.user.data,
    };
};

const Dashboard = (props) => {
    useEffect(() => {
        window.localStorage.removeItem('isTerminal');
        // setTimeout(() => {
        // 	// openModal('order-summary', { orderCode: 'O971AC43MYO' });
        // 	// openModal('update-order', { orderCode: 'O971AC43MYO' });
        // 	// openModal('client', { clientCode: 'testogluosman' });
        // 	// openModal('create-order');
        // 	openModal('create-express-order');
        // 	// openModal('order-list');
        // }, 100);
    }, [])
    return (
        <main className="page admin-dashboard">
            <div className="grid-container">
                <div className="row">
                    <div className="col x8">
                        {(props.userData && props.userData.is_owner) &&
                        <BalanceWarnings/>
                        }
                        <div className="row">
                            <div className="col">
                                <PaymentGraphics/>
                            </div>
                        </div>

                        {props.userData.company.product_terminal_status !== 2 && (
                            <div className="row">
                                <div className="col">
                                    <PaymentList plain/>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="col x4">
                        <div className="row">
                            <div className="col">
                                <PaymentReports/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <PaymentWarnings/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}

const PaymentGraphics = (props) => {
    const [data, setData] = useState(false);

    const [filterCurrency, setFilterCurrency] = useState(currencyTypes[0]);
    const [filterStartDate, setFilterStartDate] = useState(startOfMonth(subMonths(today, 1)));
    const [filterEndDate, setFilterEndDate] = useState(today);

    const updateData = useCallback(debounce(() => {
        setData(false);

        reportServices.getPaymentGraphics({
            price_type_id: filterCurrency.value,
            start_date: format(filterStartDate, 'yyyy-MM-dd') + ' 00:00:00',
            end_date: format(filterEndDate, 'yyyy-MM-dd') + ' 23:59:59',
        }).then((payload) => {
            let newData = {...payload};

            let chartData = [];

            for (const date in newData.char) {
                chartData.push({
                    name: formatDate(date, 'd MMMM yyyy'),
                    shortName: formatDate(date, 'dd.MM.yy'),
                    'Ödemeler': newData.char[date][0],
                    'Açılan Talepler': newData.char[date][1],
                })
            }

            newData.char = chartData;

            setData(newData);
        }).catch(() => {
        })
    }, 100, {leading: false}), [filterCurrency, filterStartDate, filterEndDate])

    useEffect(() => {
        updateData();
    }, [filterCurrency, filterStartDate, filterEndDate, updateData]);

    return (
        <section className="section dashboard-payment-graphics portlet">
            <div className="portlet-header">
                <h2 className="portlet-title">Ödemelerin Gelişimi</h2>

                <div className="header-filters">
                    <div className="filters-currency">
                        {currencyTypes.map((currency) => (
                            <Btn
                                key={currency.symbol}
                                onClick={() => {
                                    setFilterCurrency(currency)
                                }}
                                className={'filters-btn currency-option' + (filterCurrency.symbol === currency.symbol ? ' active' : '')}
                                small white>{currency.symbol}</Btn>
                        ))}
                    </div>

                    <FormInput
                        type="date"
                        range plain
                        placeholder="Tarih Aralığı"
                        className="filters-daterange lower"
                        onChange={(value) => {
                            setFilterStartDate(value[0]);
                            setFilterEndDate(value[1]);
                        }}
                        value={[filterStartDate, filterEndDate]}
                        startDateName="order_start_date"
                        endDateName="order_due_date"/>

                    <Btn
                        small white
                        className="filters-btn filters-refresh"
                        onClick={updateData}
                        icon="refresh"/>
                </div>
            </div>

            <div className="portlet-section bottom graphics-datawrap loader-container">
                <Loader loading={!data}/>
                {data &&
                <div className="portlet-section bottom">
                    <div className="graphics-chart chart-container">
                        <ResponsiveContainer width="100%" height="100%">
                            <LineChart data={data.char}>
                                <CartesianGrid horizontal={false}/>
                                <Legend
                                    verticalAlign="top"
                                    align="left"
                                    iconType="circle"
                                    wrapperStyle={{
                                        paddingBottom: "2rem"
                                    }}
                                    padding={{top: 0, left: 0, right: 0, bottom: 0}}/>
                                <Tooltip content={<CustomTooltip currency={filterCurrency}/>}/>
                                <XAxis
                                    tickLine={false}
                                    tick={{fontSize: '1.2rem', fill: '#7f9bb5'}}
                                    dataKey="shortName"/>
                                <Line
                                    strokeWidth={2}
                                    dataKey="Ödemeler"
                                    id="Ödemeler"
                                    stroke="#ddc061"/>
                                <Line
                                    strokeWidth={2}
                                    dataKey="Açılan Talepler"
                                    id="Açılan Talepler"
                                    stroke="#53bdea"/>
                            </LineChart>
                        </ResponsiveContainer>
                    </div>

                    <div className="graphics-numbers">
                        <div className="numbers-section">
                            <strong className="section-title">Alınan Ödemeler</strong>

                            {data.price_type_total.map((currency, nth) => (
                                <div className="numbers-row" key={nth}>
                                    <Pricebox
                                        className="row-amount currency"
                                        price={parseFloat(currency.total_price) - parseFloat(currency.total_refund_price)}
                                        currency={currency.currency_symbol}/>
                                    <div className="row-total">{currency.total_count} İşlem</div>
                                </div>
                            ))}
                        </div>
                        <div className="numbers-section">
                            <strong className="section-title">Ödeme Araçları Dağılımı</strong>

                            {data.payment_type_total.map((type, nth) => (
                                <div className="numbers-row" key={nth}>
                                    <div className="row-title">{type.name}</div>
                                    <Pricebox
                                        className="row-amount"
                                        price={type.total_price}/>
                                    <div className="row-total">{type.total_count} İşlem</div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                }
            </div>
        </section>
    )
}

const CustomTooltip = (props) => {

    if (props.active && props.payload.length) {
        return (
            <div className="custom-tooltip">
                <strong className="tooltip-title">{props.payload[0].payload.name}</strong>

                {props.payload.map((line, nth) => (
                    <div className="tooltip-group" key={nth}>
                        <span className="group-title">{line.dataKey}</span>
                        <span className="group-value" style={{color: line.stroke}}><Pricebox
                            currency={props.currency.symbol} price={line.value}/></span>
                    </div>
                ))}
            </div>
        )
    } else {
        return false;
    }
}

const BalanceWarnings = (props) => {
    const [warnings, setWarnings] = useState(false);

    useEffect(() => {
        reportServices.getBalanceStatusReports().then((payload) => {
            setWarnings(payload.filter((report) => {
                return parseInt(report.credit) < 0;
            }));
        }).catch(() => {
        })
    }, []);

    if (warnings && warnings.length) {
        return (
            <div className="row">
                <div className="col">
                    <section className="section dashboard-balance-warnings">
                        {warnings.map((warning, nth) => (
                            <div className="warnings-warning" key={nth}>
                                <i className="icon-alert"></i>
                                Hesabınıza {warning.currency_code} yüklemesi yüklemeniz gerekmektedir. <span
                                className="warning-balance">({warning.credit} {warning.currency_symbol})</span>
                            </div>
                        ))}
                    </section>
                </div>
            </div>
        )
    } else {
        return false;
    }
}

const PaymentWarnings = (props) => {
    const [payments, setPayments] = useState(false);

    useEffect(() => {
        orderServices.listPayments({status_code: 0, per_page: 14}).then((payload) => {
            setPayments(payload.payments.filter((payment) => {
                return payment.error_message !== null
            }));
        }).catch(() => {
        })
    }, []);

    return (
        <section className="section dashboard-payment-warnings portlet error">
            <div className="portlet-header">
                <h2 className="portlet-title">Uyarılar</h2>
            </div>

            <div className="portlet-section bottom loader-container low">
                <Loader loading={!payments}/>
                {payments &&
                <React.Fragment>
                    {payments.length > 0 ?
                        <React.Fragment>
                            {payments.map((payment, nth) => (
                                <div className="warnings-warning" key={nth}>
                                    <div className="warning-info">
                                        <i className="icon-alert"></i>
                                        <span className="info-date">{formatDate(payment.created_at)}</span> - <Link
                                        className="info-order" href="orderDetail"
                                        params={{id: payment.order.business_order_code}}>{payment.card_name}</Link>
                                    </div>

                                    <p className="warning-message">{payment.error_message}</p>
                                </div>
                            ))}
                        </React.Fragment>
                        :
                        <p>Uyarı yok</p>
                    }
                </React.Fragment>
                }
            </div>
        </section>
    )
}

const PaymentReports = (props) => {
    const [reports, setReports] = useState(false);

    useEffect(() => {
        reportServices.getExpressReports().then((payload) => {
            setReports(payload);
        }).catch(() => {
        })
    }, []);

    return (
        <section className="section dashboard-payment-reports">
            <div className="portlet reports-group">
                <div className="portlet-header small">
                    <h2 className="portlet-title">Bugün Gerçekleşen Ödemeler</h2>
                </div>
                <div className="portlet-section bottom reports-paymentcount loader-container">
                    <Loader loading={!reports}/>
                    <strong className="group-totalnum">{reports.payment_today_success_count}</strong>

                    {(reports && reports.payment_today_amount && reports.payment_today_amount) &&
                    <div className="group-currencies">
                        {reports.payment_today_amount.map((group, nth) => (
                            <div className="currencies-currency" key={nth}>
                                <div className="currency-symbol">
                                    {group.currency_symbol}
                                </div>
                                <div className="currency-total">
                                    <Pricebox currency={false} price={group.total_price}/>
                                </div>
                                <div className="currency-count">
                                    {group.total_count} İşlem
                                </div>
                            </div>
                        ))}
                    </div>
                    }
                </div>
            </div>

            <div className="portlet reports-group">
                <div className="portlet-header small">
                    <h2 className="portlet-title">Geciken Ödemeler</h2>
                </div>
                <div className="portlet-section bottom loader-container">
                    <Loader loading={!reports}/>
                    {reports &&
                    <React.Fragment>
                        {(reports.expired_orders_total_amount && reports.expired_orders_total_amount.length > 0) ?
                            <div className="group-currencies">
                                {reports.expired_orders_total_amount.map((group, nth) => (
                                    <div className="currencies-currency" key={nth}>
                                        <div className="currency-symbol">
                                            {group.currency_symbol}
                                        </div>
                                        <div className="currency-total">
                                            <Pricebox currency={false} price={group.total_remaining_amount}/>
                                        </div>
                                        <div className="currency-count">
                                            <Link
                                                href="orders"
                                                params={{query: 'status_code=3&price_type_id=' + getCurrency(group.currency_code).id}}>
                                                {group.order_count} Ödeme
                                            </Link>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            :
                            <p>Geciken ödemeniz yok.</p>
                        }
                    </React.Fragment>
                    }
                </div>
            </div>

            <div className="portlet reports-group">
                <div className="portlet-header small">
                    <h2 className="portlet-title">Bekleyen Açık Ödemeler</h2>
                </div>
                <div className="portlet-section bottom loader-container">
                    <Loader loading={!reports}/>
                    {reports &&
                    <React.Fragment>
                        {(reports.payment_open_total_amount && reports.payment_open_total_amount.length > 0) ?
                            <div className="group-currencies">
                                {reports.payment_open_total_amount.map((group, nth) => (
                                    <div className="currencies-currency" key={nth}>
                                        <div className="currency-symbol">
                                            {group.currency_symbol}
                                        </div>
                                        <div className="currency-total">
                                            <Pricebox currency={false} price={group.total_remaining_amount}/>
                                        </div>
                                        <div className="currency-count">
                                            <Link
                                                href="orders"
                                                params={{query: 'status_code=0&price_type_id=' + getCurrency(group.currency_code).id}}>
                                                {group.order_count} Ödeme
                                            </Link>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            :
                            <div>Bekleyen açık ödemeniz yok.</div>
                        }
                    </React.Fragment>
                    }
                </div>
            </div>
        </section>
    )
}

export default connect(mapStateToProps)(Dashboard);